/**
 * Color constants for analytics charts and metrics
 * Using semantic design tokens from alias.css for consistent theming
 */
export const ANALYTICS_COLORS = {
    VIEWS: 'var(--color-success-main)', // Success green - represents page views/store visits
    REVENUE: 'var(--color-brand-main)', // Brand purple - represents revenue/sales
    LEADS: 'var(--color-critical-main)', // Critical red - represents leads/subscribers
    TRAFFIC: 'var(--color-brand-main)', // Info blue - represents traffic sources
} as const;

/**
 * Analytics metric ID constants for chart configuration
 */
export const ANALYTICS_METRIC_IDS = {
    VIEWS: 'views',
    REVENUE: 'revenue',
    LEADS: 'leads',
} as const;

// Re-export global date range types for convenience
export { DATE_RANGE_TYPES as RANGE_TYPES, type DateRangeType } from '@/lib/constants/dateFormats';

/**
 * Period length constants for analytics data aggregation
 * Determines how data points are grouped based on time range
 */
export const PERIOD_LENGTHS = {
    DAILY: 1, // 1 day per data point
    BI_DAILY: 2, // 2 days per data point
    WEEKLY: 7, // 7 days per data point
    BI_WEEKLY: 14, // 14 days per data point
} as const;

/**
 * Day range thresholds for period length calculation
 * Determines when to switch between aggregation levels
 */
export const PERIOD_THRESHOLDS = {
    DAILY_MAX: 30, // Use daily aggregation for 0-30 days
    BI_DAILY_MAX: 60, // Use bi-daily aggregation for 31-60 days
    WEEKLY_MAX: 90, // Use weekly aggregation for 61-90 days
    // 90+ days uses bi-weekly aggregation
} as const;

/**
 * Default values for analytics
 */
export const ANALYTICS_DEFAULTS = {
    DEFAULT_DAY_RANGE: 14,
    TOP_N_ITEMS: 5,
} as const;

/**
 * Chart configuration constants
 */
export const CHART_CONFIG = {
    HEIGHT: 394,
    MAX_DATE_OFFSET: 1, // Days to add to current date for max date
} as const;
